import React from "react";
import theme, { Theme } from "app/Theme/Theme";
import { StyleSheet, View } from "react-native";
import { MainTitle } from "./MainTitle";
import { ResponsiveValue } from "@shopify/restyle";

const styles = StyleSheet.create({
  main: {
    position: "relative",
    overflow: "hidden",
    backgroundColor: theme.colors["neutral.900"],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
});

export interface IEmptyPictureProps {
  variant?: ResponsiveValue<keyof Theme["header"], Theme>;
  size?: number;
  firstName?: string;
  stylePicture?: {};
  hasPlusSign?: boolean;
}

const EmptyPicture = ({
  variant = "l10-bold",
  size = 120,
  firstName = "Microdoing",
  stylePicture = {},
  hasPlusSign = false,
}: IEmptyPictureProps) => {
  return (
    <View
      style={[
        styles.main,
        stylePicture,
        { height: size, width: size, borderRadius: size / 2 },
      ]}
    >
      <MainTitle variant={variant} textAlign="center" color="neutral.white">
        {!!hasPlusSign && firstName}
        {!!firstName.length && !hasPlusSign && firstName[0]}
      </MainTitle>
    </View>
  );
};

export default EmptyPicture;
